<template>
  <div>
    <div
      class="message"
      style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;"
    >
      <div style="font-size: 12px;" :style="{ color: 'black' }">
        <div style="padding: 5px 8px 6px;" :style="{ 'background-color': '#F1F0F0' }">
          <span style="line-height:15.36px;">
            <template v-if="currentLang == 'th'">
              📄เลขที่การสั่งซื้อ: 1
              <br />
              REF: {{ $t('Bank Transfer') }} <br />-----------------------------
              <br />ชำระเงินเรียบร้อย: <br />จำนวนเงิน 200 <br />สถานะการจัดส่งสินค้า: รอการจัดส่ง
              <br />จัดส่งที่อยู่: <br />-
              <br />
            </template>
            <template v-else-if="currentLang == 'la'">
              📄ເລກທີ່ຄ່າສັ່ງຊື້: 1
              <br />
              REF: {{ $t('Bank Transfer') }} <br />-----------------------------
              <br />ຊໍາລະເງິນຄົບຖ້ວນ: <br />ຈຳນວນເງີນ 200 <br />ສະຖານະການຈັດສົ່ງ: ລໍຖ້າການຈັດສົ່ງ
              <br />ທີ່ຢູ່ສົ່ງ: <br />-
              <br />
            </template>
            <template v-else>
              📄Order No.: 1
              <br />
              REF: {{ $t('Bank Transfer') }} <br />----------------------------- <br />Complete
              payment: <br />Amount 200 <br />Delivery status: Wait for delivery <br />Delivery
              address: <br />-
              <br />
            </template>
          </span>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ViewReceiptViewer.vue